module.exports = __webpack_public_path__ + "assets/img/CheckTwin.bab25805.svg";